/**
 * Search result — a verse matching a text search query.
 */
import { z } from 'zod';
export const SearchResultSchema = z.object({
    testament: z.number(),
    bookNumber: z.number(),
    chapterNumber: z.number(),
    verseNumber: z.number(),
    text: z.string(),
});
//# sourceMappingURL=search-result.js.map